
import { shuffleItems } from "../utils/functions";
import axios from 'axios'

export const fetchAllData = async () => {

  // Sections are a separate, tiny (~1KB) endpoint. Fetched in parallel so it
  // costs no extra latency, and a failure there must not take the catalogue
  // down with it — the menu still works without merchandising rows.
  const [productRes, sectionRes] = await Promise.all([
    axios.get(`${process.env.REACT_APP_BASE_URL}/product/all`),
    axios.get(`${process.env.REACT_APP_BASE_URL}/menu/sections`).catch(() => null),
  ]);

  return {
    products: shuffleItems(productRes.data.products),
    deliveryFees: productRes.data.deliveryFees,
    categories: productRes.data.categories,
    sections: sectionRes?.data?.sections || [],
  };
}
